module.exports = __webpack_public_path__ + "static/media/Bg3.16e2d960.png";